<template>
	<el-container class="mass-send-page" @click.native="closeContextMenu">
		<resizable-aside :default-width="480" :min-width="320" :max-width="560" storage-key="mass-send-aside-width">
			<div class="mass-aside">
				<div class="header">
					<el-input class="search-text" size="small" placeholder="搜索" v-model="searchText">
						<i class="el-icon-search el-input__icon" slot="prefix"> </i>
					</el-input>
				</div>
				<el-scrollbar class="group-scroll">
					<div class="group-list">
						<div v-for="group in filteredGroups" :key="group.id" class="group-block">
							<div class="group-title" @click="toggleGroup(group.id)" @contextmenu.prevent.stop="openGroupMenu($event, group)">
								<i :class="isGroupOpen(group.id) ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
							<el-checkbox class="group-checkbox"
								:value="isGroupAllSelected(group)"
								:indeterminate="isGroupPartialSelected(group)"
								@change="checked => onToggleGroupMembers(group, checked)"
								@click.native.stop></el-checkbox>
							<span class="group-name">{{ group.name || '-' }}</span>
								<span class="group-count">{{ group.memberCount || group.members.length || 0 }}</span>
							</div>
							<div v-show="isGroupOpen(group.id)" class="member-list">
								<div v-for="(members, letter) in buildMemberMap(group.members)" :key="`${group.id}_${letter}`">
									<div class="letter">{{ letter }}</div>
									<div v-for="member in members" :key="`${group.id}_${member.id}`" class="member-item"
						@contextmenu.prevent.stop="openMemberMenu($event, group, member)"
						@click="onToggleMember(group, member, !isSelected(group.id, member.id))">
						<el-checkbox :value="isSelected(group.id, member.id)"
							@change="checked => onToggleMember(group, member, checked)" @click.native.stop></el-checkbox>
						<head-image :size="48" :id="member.id" :url="member.headImage" :name="member.showNickName"
							:isShowUserInfo="false"></head-image>
										<span class="member-name">{{ member.showNickName }}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="add-group" @click="openGroupDialog('add')">
							<i class="el-icon-circle-plus-outline"></i>
							<span>新增分组</span>
						</div>
					</div>
				</el-scrollbar>
				<div v-if="selectedMembers.length" class="selected-actions">
					<el-button size="small" @click="changeSelectedGroup">更改分组</el-button>
					<el-button size="small" @click="removeSelectedFromGroup">移出分组</el-button>
				</div>
			</div>
		</resizable-aside>
		<el-container class="mass-container">
			<div class="mass-header">群发助手</div>
			<div v-if="selectedMembers.length" class="selected-tip">
				<span>已选择发送对象：</span>{{ selectedNames }}
			</div>
			<el-scrollbar ref="recordScroll" class="record-scroll">
				<div class="record-list">
					<div v-for="record in records" :key="record.id" class="record-item">
						<div class="record-time">{{ record.createTime }}</div>
						<div class="record-card">
							<div class="record-title">群发消息</div>
							<div v-if="record.contentType === 0" class="record-content" v-html="$emo.transform($str.html2Escape(record.content), 'emoji-normal')"></div>
							<div v-else class="record-media-list">
								<div class="record-media" :class="media(record.content).originUrl ? 'record-media-image' : (media(record.content).videoUrl ? 'record-media-video' : 'record-media-audio')" :style="mediaStyle(record.content)">
									<el-image v-if="media(record.content).originUrl" :src="media(record.content).thumbUrl || media(record.content).originUrl" :preview-src-list="[media(record.content).originUrl]" fit="cover"></el-image>
									<video v-else-if="media(record.content).videoUrl" :src="media(record.content).videoUrl" :poster="media(record.content).coverUrl" controls></video>
									<audio v-else-if="media(record.content).url" :src="media(record.content).url" controls></audio>
									<span v-else class="record-media-unknown">不支持的消息类型</span>
								</div>
							</div>
							<div class="recipient-line">
								<span>已发送给{{ record.recipientCount || (record.recipients || []).length || 0 }}位好友：</span>{{ formatRecipients(record) }}
							</div>
							<div class="record-footer">
								<el-button size="small" type="primary" plain @click="onResend(record)">再发一条</el-button>
							</div>
						</div>
					</div>
					<div v-if="recordLoading" class="load-tip">加载中...</div>
					<div v-else-if="!hasMore && records.length" class="load-tip">没有更多了</div>
					<no-data-tip v-else-if="!records.length" tip="暂无群发记录"></no-data-tip>
				</div>
			</el-scrollbar>
			<div v-if="selectedMembers.length" class="send-panel">
				<div class="send-content-area">
					<div class="chat-tool-bar">
						<div class="icon iconfont icon-emoji" ref="emotion" @click.stop="showEmotionBox()"></div>
						<div :title="'发送图片'">
							<file-upload :action="'/image/upload'" :maxSize="10 * 1024 * 1024"
								:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif']"
								@success="onImageSuccess" @fail="onImageFail">
								<i class="el-icon-picture-outline"></i>
							</file-upload>
						</div>
						<div :title="'发送视频'">
							<file-upload :action="'/video/upload'" :maxSize="50 * 1024 * 1024"
								:fileTypes="['video/mp4', 'video/ogg', 'video/webm']"
								@success="onVideoSuccess" @fail="onVideoFail">
								<i class="el-icon-film"></i>
							</file-upload>
						</div>
						<div :title="'发送语音'" class="el-icon-microphone" @click="showRecordBox()"></div>
					</div>
					<chat-input ref="chatInputEditor" @submit="onTextSubmit"></chat-input>
					<div class="send-btn-area">
						<el-button type="primary" icon="el-icon-s-promotion" @click="notifySend()">发送</el-button>
					</div>
				</div>
			</div>
		</el-container>

		<chat-emotion ref="emoBox" @emotion="onEmotion"></chat-emotion>
		<chat-record :visible="showRecord" @close="closeRecordBox" @send="onSendRecord"></chat-record>

		<el-dialog :visible.sync="confirmVisible" :title="'发送给' + selectedMembers.length + '位好友'" width="480px"
			custom-class="mass-confirm-dialog" :close-on-click-modal="false">
			<div class="confirm-content">
				<span class="confirm-label">发送内容：</span>
				<span v-if="pendingMessage && pendingMessage.type === 0" class="confirm-preview"
					v-html="$emo.transform($str.html2Escape(pendingMessage.content), 'emoji-normal')"></span>
				<span v-else class="confirm-preview">{{ previewText }}</span>
			</div>
			<div slot="footer">
				<el-button @click="confirmVisible = false">取消</el-button>
				<el-button type="primary" :loading="isSending" @click="doSend">发送</el-button>
			</div>
		</el-dialog>

		<div v-if="contextMenu.show" class="context-mask" @click.stop="closeContextMenu" @contextmenu.prevent="closeContextMenu">
			<div class="mass-context-menu" :style="{ left: contextMenu.x + 'px', top: contextMenu.y + 'px' }">
				<div v-for="item in contextMenu.items" :key="item.key" class="context-item" :class="{ danger: item.danger }"
					@click.stop="onContextSelect(item)">{{ item.name }}</div>
			</div>
		</div>

		<el-dialog :visible.sync="groupDialog.visible" :title="groupDialog.mode === 'add' ? '新增分组' : '修改分组名'"
			width="480px" custom-class="mass-group-dialog" :close-on-click-modal="false">
			<el-input v-model="groupDialog.name" placeholder="请输入分组名称"></el-input>
			<div slot="footer">
				<el-button @click="groupDialog.visible = false">取消</el-button>
				<el-button type="primary" @click="submitGroup">确认</el-button>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="moveGroupDialog.visible" title="更改分组" width="480px" custom-class="mass-group-dialog"
			:close-on-click-modal="false">
			<el-select v-model="moveGroupDialog.groupId" class="move-group-select" placeholder="请选择目标分组">
				<el-option v-for="group in groups" :key="group.id" :label="group.name" :value="group.id"></el-option>
			</el-select>
			<div slot="footer">
				<el-button @click="moveGroupDialog.visible = false">取消</el-button>
				<el-button type="primary" @click="submitMoveGroup">确认</el-button>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="editMembersDialog.visible" title="编辑分组成员" width="680px"
			custom-class="mass-edit-members-dialog" :close-on-click-modal="false">
			<div class="edit-members">
				<div class="edit-box left-box">
					<div class="edit-box-header">
						<el-input placeholder="搜索好友" v-model="editMembersDialog.searchText" size="small">
							<i class="el-icon-search el-input__icon" slot="prefix"></i>
						</el-input>
					</div>
					<el-scrollbar class="edit-member-scroll">
						<div v-for="friend in editMembersDialog.unjoinedFriends" :key="friend.id"
							class="edit-member-item"
							v-show="(friend.showNickName || '').includes(editMembersDialog.searchText)"
							@click="onAddMember(friend)">
							<head-image :size="36" :id="friend.id" :url="friend.headImage" :name="friend.showNickName"
								:isShowUserInfo="false"></head-image>
							<span class="edit-member-name">{{ friend.showNickName }}</span>
							<i class="el-icon-circle-plus edit-add-icon"></i>
						</div>
						<div v-if="!editMembersDialog.unjoinedFriends.length" class="edit-empty">暂无可添加的好友</div>
					</el-scrollbar>
					<div class="edit-box-footer">
						<el-button type="text" class="edit-all-btn" :disabled="!editMembersDialog.unjoinedFriends.length"
							@click="onAddAllMembers">全部加入</el-button>
					</div>
				</div>
				<div class="edit-arrow el-icon-d-arrow-right"></div>
				<div class="edit-box right-box">
					<div class="edit-box-header">
						<span class="edit-tip">已加入 {{ editMembersDialog.joinedFriends.length }} 人</span>
					</div>
					<el-scrollbar class="edit-member-scroll">
						<div v-for="friend in editMembersDialog.joinedFriends" :key="friend.id"
							class="edit-member-item" @click="onRemoveMember(friend)">
							<head-image :size="36" :id="friend.id" :url="friend.headImage" :name="friend.showNickName"
								:isShowUserInfo="false"></head-image>
							<span class="edit-member-name">{{ friend.showNickName }}</span>
							<i class="el-icon-remove edit-remove-icon"></i>
						</div>
						<div v-if="!editMembersDialog.joinedFriends.length" class="edit-empty">暂未加入任何成员</div>
					</el-scrollbar>
					<div class="edit-box-footer">
						<el-button type="text" class="edit-all-btn" :disabled="!editMembersDialog.joinedFriends.length"
							@click="onRemoveAllMembers">全部移出</el-button>
					</div>
				</div>
			</div>
			<div slot="footer">
				<el-button @click="editMembersDialog.visible = false">取消</el-button>
				<el-button type="primary" @click="submitEditMembers">确认</el-button>
			</div>
		</el-dialog>
	</el-container>
</template>

<script>
import { pinyin } from 'pinyin-pro';
import HeadImage from '../components/common/HeadImage.vue';
import ResizableAside from '../components/common/ResizableAside.vue';
import ChatInput from '../components/chat/ChatInput.vue';
import ChatEmotion from '../components/chat/ChatEmotion.vue';
import ChatRecord from '../components/chat/ChatRecord.vue';
import FileUpload from '../components/common/FileUpload.vue';
import NoDataTip from '../components/common/NoDataTip.vue';

export default {
	name: 'massSend',
	components: {
		HeadImage,
		ResizableAside,
		ChatInput,
		ChatEmotion,
		ChatRecord,
		FileUpload,
		NoDataTip
	},
	data() {
		return {
			searchText: '',
			groups: [],
			openGroupIds: [],
			selectedMemberMap: {},
			activeGroup: null,
			records: [],
			page: 1,
			size: 10,
			total: 0,
			recordLoading: false,
			showRecord: false,
			confirmVisible: false,
			pendingMessage: null,
			isSending: false,
			contextMenu: {
				show: false,
				x: 0,
				y: 0,
				type: '',
				group: null,
				member: null,
				items: []
			},
			groupDialog: {
				visible: false,
				mode: 'add',
				id: 0,
				name: '',
				sort: 0
			},
			moveGroupDialog: {
				visible: false,
				groupId: null
			},
			editMembersDialog: {
				visible: false,
				searchText: '',
				group: null,
				joinedFriends: [],
				unjoinedFriends: []
			}
		}
	},
	computed: {
		filteredGroups() {
			const keyword = this.searchText.trim();
			if (!keyword) return this.groups;
			return this.groups.map(group => {
				const members = group.members.filter(member => (member.showNickName || '').includes(keyword));
				return { ...group, members };
			}).filter(group => (group.name || '').includes(keyword) || group.members.length);
		},
		selectedMembers() {
			return Object.values(this.selectedMemberMap);
		},
		selectedNames() {
			return this.selectedMembers.map(member => member.showNickName).join('、');
		},
		hasMore() {
			return this.records.length < this.total;
		},
		friendIds() {
			return this.selectedMembers.map(member => member.id).filter(Boolean);
		},
		previewText() {
			const msg = this.pendingMessage;
			if (!msg) return '';
			// 0:文字 1:图片 3:语音 4:视频
			if (msg.type === 1) return '[图片]';
			if (msg.type === 4) return '[视频]';
			if (msg.type === 3) {
				let duration = 0;
				try {
					const data = JSON.parse(msg.content);
					duration = data.duration || 0;
				} catch (e) {
					// ignore parse error
				}
				return `[语音] ${duration}秒`;
			}
			return '';
		}
	},
	mounted() {
		this.loadGroups();
		this.loadRecords();
		this.$nextTick(() => {
			const wrap = this.$refs.recordScroll && this.$refs.recordScroll.wrap;
			if (wrap) wrap.addEventListener('scroll', this.onRecordsScroll);
		});
	},
	beforeDestroy() {
		const wrap = this.$refs.recordScroll && this.$refs.recordScroll.wrap;
		if (wrap) wrap.removeEventListener('scroll', this.onRecordsScroll);
	},
	methods: {
		loadGroups() {
			this.$http({
				url: '/friend/group/list',
				method: 'get'
			}).then(groups => {
				this.groups = (groups || []).map(group => ({
					...group,
					members: group.members || []
				}));
				this.openGroupIds = this.groups.map(group => group.id);
			});
		},
		loadRecords(reset = false) {
			if (this.recordLoading) return;
			if (reset) {
				this.page = 1;
				this.records = [];
			}
			this.recordLoading = true;
			this.$http({
				url: '/massMessage/list',
				method: 'get',
				params: {
					page: this.page,
					size: this.size
				}
			}).then(data => {
				const records = (data && data.records) || [];
				this.total = (data && data.total) || 0;
				this.records = reset ? records : this.records.concat(records);
				this.page += 1;
			}).finally(() => {
				this.recordLoading = false;
			});
		},
		onRecordsScroll(e) {
			const target = e.target;
			if (!this.hasMore || this.recordLoading) return;
			if (target.scrollHeight - target.scrollTop - target.clientHeight < 80) {
				this.loadRecords();
			}
		},
		toggleGroup(groupId) {
			if (this.isGroupOpen(groupId)) {
				this.openGroupIds = this.openGroupIds.filter(id => id !== groupId);
			} else {
				this.openGroupIds.push(groupId);
			}
		},
		isGroupOpen(groupId) {
			return this.openGroupIds.includes(groupId);
		},
		buildMemberMap(members) {
			const map = {};
			(members || []).forEach(member => {
				const letter = this.firstLetter(member.showNickName || '').toUpperCase();
				const key = /^[A-Z]$/.test(letter) ? letter : '#';
				if (!map[key]) map[key] = [];
				map[key].push(member);
			});
			return Object.keys(map).sort((a, b) => {
				if (a === '#') return 1;
				if (b === '#') return -1;
				return a.localeCompare(b);
			}).reduce((obj, key) => {
				obj[key] = map[key];
				return obj;
			}, {});
		},
		firstLetter(text) {
			if (!text) return '#';
			return pinyin(text, { toneType: 'none', type: 'normal' })[0] || '#';
		},
		selectionKey(groupId, memberId) {
			return `${groupId}_${memberId}`;
		},
		isSelected(groupId, memberId) {
			return !!this.selectedMemberMap[this.selectionKey(groupId, memberId)];
		},
		isGroupAllSelected(group) {
			const members = group.members || [];
			if (!members.length) return false;
			return members.every(member => this.isSelected(group.id, member.id));
		},
		isGroupPartialSelected(group) {
			const members = group.members || [];
			if (!members.length) return false;
			const selectedCount = members.filter(member => this.isSelected(group.id, member.id)).length;
			return selectedCount > 0 && selectedCount < members.length;
		},
		onToggleGroupMembers(group, checked) {
			const map = { ...this.selectedMemberMap };
			(group.members || []).forEach(member => {
				const key = this.selectionKey(group.id, member.id);
				if (checked) {
					map[key] = { ...member, groupId: group.id };
				} else {
					delete map[key];
				}
			});
			this.selectedMemberMap = map;
		},
		onToggleMember(group, member, checked) {
			const map = { ...this.selectedMemberMap };
			const key = this.selectionKey(group.id, member.id);
			if (checked) {
				map[key] = { ...member, groupId: group.id };
			} else {
				delete map[key];
			}
			this.selectedMemberMap = map;
		},
		openGroupMenu(e, group) {
			this.activeGroup = group;
			this.openContextMenu(e, 'group', group, null, [{
				key: 'EDIT_MEMBERS',
				name: '编辑分组成员'
			}, {
				key: 'EDIT_GROUP',
				name: '修改分组名'
			}, {
				key: 'DELETE_GROUP',
				name: '删除分组',
				danger: true
			}]);
		},
		openMemberMenu(e, group, member) {
			this.activeGroup = group;
			this.openContextMenu(e, 'member', group, member, [{
				key: 'REMOVE_MEMBER',
				name: '移出该分组'
			}]);
		},
		openContextMenu(e, type, group, member, items) {
			this.contextMenu = {
				show: true,
				x: e.clientX,
				y: e.clientY,
				type,
				group,
				member,
				items
			};
			this.$nextTick(this.adjustContextMenu);
		},
		adjustContextMenu() {
			const menuH = this.contextMenu.items.length * 48 + 16;
			const menuW = 172;
			if (this.contextMenu.y > window.innerHeight - menuH) this.contextMenu.y = window.innerHeight - menuH;
			if (this.contextMenu.x > window.innerWidth - menuW) this.contextMenu.x = window.innerWidth - menuW;
		},
		closeContextMenu() {
			this.contextMenu.show = false;
			// 关闭表情窗口
			if (this.$refs.emoBox) {
				this.$refs.emoBox.close();
			}
		},
		onContextSelect(item) {
			const group = this.contextMenu.group;
			const member = this.contextMenu.member;
			this.closeContextMenu();
			if (item.key === 'EDIT_MEMBERS') {
				this.openEditMembersDialog(group);
			} else if (item.key === 'EDIT_GROUP') {
				this.openGroupDialog('edit', group);
			} else if (item.key === 'DELETE_GROUP') {
				this.deleteGroup(group);
			} else if (item.key === 'REMOVE_MEMBER') {
				this.removeMemberFromGroup(group, member);
			}
		},
		selectGroupMembers(group) {
			const map = { ...this.selectedMemberMap };
			(group.members || []).forEach(member => {
				map[this.selectionKey(group.id, member.id)] = { ...member, groupId: group.id };
			});
			this.selectedMemberMap = map;
		},
		openEditMembersDialog(group) {
			this.editMembersDialog.group = group;
			this.editMembersDialog.searchText = '';
			const memberIds = (group.members || []).map(m => m.id);
			const joined = [];
			const unjoined = [];
			this.friendStore.friends.forEach(f => {
				if (f.deleted) return;
				if (memberIds.includes(f.id)) {
					joined.push({ ...f });
				} else {
					unjoined.push({ ...f });
				}
			});
			this.editMembersDialog.joinedFriends = joined;
			this.editMembersDialog.unjoinedFriends = unjoined;
			this.editMembersDialog.visible = true;
		},
		onAddMember(friend) {
			this.editMembersDialog.unjoinedFriends = this.editMembersDialog.unjoinedFriends.filter(f => f.id !== friend.id);
			this.editMembersDialog.joinedFriends.push(friend);
		},
		onRemoveMember(friend) {
			this.editMembersDialog.joinedFriends = this.editMembersDialog.joinedFriends.filter(f => f.id !== friend.id);
			this.editMembersDialog.unjoinedFriends.push(friend);
		},
		onAddAllMembers() {
			const unjoined = this.editMembersDialog.unjoinedFriends;
			if (!unjoined.length) return;
			this.editMembersDialog.joinedFriends.push(...unjoined);
			this.editMembersDialog.unjoinedFriends = [];
		},
		onRemoveAllMembers() {
			const joined = this.editMembersDialog.joinedFriends;
			if (!joined.length) return;
			this.editMembersDialog.unjoinedFriends.push(...joined);
			this.editMembersDialog.joinedFriends = [];
		},
		submitEditMembers() {
			const group = this.editMembersDialog.group;
			const friendIds = this.editMembersDialog.joinedFriends.map(f => f.id);
			this.$http({
				url: '/friend/group',
				method: 'put',
				data: {
					id: group.id,
					name: group.name,
					sort: group.sort || 0,
					friendIds: friendIds
				}
			}).then(() => {
				this.$message.success('编辑成员成功');
				this.editMembersDialog.visible = false;
				this.loadGroups();
			});
		},
		openGroupDialog(mode, group) {
			this.groupDialog = {
				visible: true,
				mode,
				id: group ? group.id : 0,
				name: group ? group.name : '',
				sort: group ? group.sort : 0
			};
		},
		submitGroup() {
			const name = this.groupDialog.name.trim();
			if (!name) {
				this.$message.warning('请输入分组名称');
				return;
			}
			this.$http({
				url: '/friend/group',
				method: this.groupDialog.mode === 'add' ? 'post' : 'put',
				data: {
					id: this.groupDialog.id,
					name,
					sort: this.groupDialog.sort
				}
			}).then(() => {
				this.groupDialog.visible = false;
				this.$message.success(this.groupDialog.mode === 'add' ? '新增成功' : '修改成功');
				this.loadGroups();
			});
		},
		deleteGroup(group) {
			this.$confirm(`确认删除分组“${group.name}”？`, '删除分组', {
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/friend/group/${group.id}`,
					method: 'delete'
				}).then(() => {
					this.$message.success('删除成功');
					this.loadGroups();
				});
			});
		},
		removeMemberFromGroup(group, member) {
			this.$confirm(`确认将“${member.showNickName}”移出分组“${group.name}”？`, '移出分组', {
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: '/friend/group/members/remove',
					method: 'put',
					data: {
						groupId: group.id,
						friendIds: [member.id]
					}
				}).then(() => {
					this.$message.success('移出成功');
					delete this.selectedMemberMap[this.selectionKey(group.id, member.id)];
					this.selectedMemberMap = { ...this.selectedMemberMap };
					this.loadGroups();
				});
			});
		},
		changeSelectedGroup() {
			if (!this.selectedMembers.length) {
				return;
			}
			const firstGroupId = this.selectedMembers[0].groupId;
			const targetGroup = this.groups.find(group => group.id !== firstGroupId);
			this.moveGroupDialog = {
				visible: true,
				groupId: targetGroup ? targetGroup.id : firstGroupId || null
			};
		},
		submitMoveGroup() {
			const targetGroupId = this.moveGroupDialog.groupId;
			if (!targetGroupId) {
				this.$message.warning('请选择目标分组');
				return;
			}
			const friendIds = this.selectedMembers.map(member => member.id);
			this.$http({
				url: '/friend/group/members/move',
				method: 'put',
				data: {
					groupId: targetGroupId,
					friendIds
				}
			}).then(() => {
				this.$message.success('更改分组成功');
				this.moveGroupDialog.visible = false;
				this.selectedMemberMap = {};
				this.loadGroups();
			});
		},
		removeSelectedFromGroup() {
			if (!this.selectedMembers.length) {
				return;
			}
			const groupId = this.selectedMembers[0].groupId;
			const friendIds = this.selectedMembers.filter(member => member.groupId === groupId).map(member => member.id);
			if (!friendIds.length) {
				this.$message.warning('请选择同一分组的成员');
				return;
			}
			this.$confirm(`确认将选中的 ${friendIds.length} 位好友移出分组？`, '移出分组', {
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: '/friend/group/members/remove',
					method: 'put',
					data: {
						groupId,
						friendIds
					}
				}).then(() => {
					this.$message.success('移出成功');
					friendIds.forEach(friendId => {
						delete this.selectedMemberMap[this.selectionKey(groupId, friendId)];
					});
					this.selectedMemberMap = { ...this.selectedMemberMap };
					this.loadGroups();
				});
			});
		},
		formatRecipients(record) {
			return (record.recipients || []).map(item => item.showNickName).join('、');
		},
		media(content) {
			try {
				return JSON.parse(content) || {};
			} catch (e) {
				return {};
			}
		},
		mediaStyle(content) {
			const data = this.media(content);
			if (!data.width || !data.height) return {};
			const isVideo = !!data.videoUrl;
			const maxW = isVideo ? 320 : 200;
			const maxH = isVideo ? 240 : 200;
			const ratio = Math.min(maxW / data.width, maxH / data.height, 1);
			return {
				width: Math.round(data.width * ratio) + 'px',
				height: Math.round(data.height * ratio) + 'px'
			};
		},
		onResend(record) {
			const map = {};
			(record.recipients || []).forEach(member => {
				const group = this.groups.find(item => (item.members || []).some(groupMember => groupMember.id === member.id));
				if (group) {
					map[this.selectionKey(group.id, member.id)] = { ...member, groupId: group.id };
				}
			});
			this.selectedMemberMap = map;
			this.$message.success('已选择好友');
		},
		showEmotionBox() {
			let width = this.$refs.emotion.offsetWidth;
			let left = this.$elm.fixLeft(this.$refs.emotion);
			let top = this.$elm.fixTop(this.$refs.emotion);
			this.$refs.emoBox.open({
				x: left + width / 2,
				y: top
			});
		},
		onEmotion(payload) {
			if (typeof payload === 'string') {
				this.$refs.chatInputEditor.insertEmoji(payload);
			}
		},
		showRecordBox() {
			this.showRecord = true;
		},
		closeRecordBox() {
			this.showRecord = false;
		},
		onSendRecord(data) {
			this.showRecord = false;
			this.openConfirm(3, JSON.stringify(data));
		},
		onImageSuccess(data) {
			this.openConfirm(1, JSON.stringify(data));
		},
		onImageFail() {
			this.$message.error('图片上传失败');
		},
		onVideoSuccess(data) {
			this.openConfirm(4, JSON.stringify(data));
		},
		onVideoFail() {
			this.$message.error('视频上传失败');
		},
		notifySend() {
			this.$refs.chatInputEditor.submit();
		},
		onTextSubmit(fullList) {
			let text = '';
			fullList.forEach(item => {
				if (item.type === 'text') {
					text += item.content;
				}
			});
			text = text.trim();
			if (!text) {
				this.$message.warning('不能发送空白消息');
				return;
			}
			this.openConfirm(0, text);
		},
		openConfirm(type, content) {
			if (!this.friendIds.length) {
				this.$message.warning('请先选择发送对象');
				return;
			}
			this.pendingMessage = { type, content };
			this.confirmVisible = true;
		},
		doSend() {
			if (this.isSending || !this.pendingMessage) return;
			this.isSending = true;
			this.$http({
				url: '/massMessage/send',
				method: 'post',
				data: {
					friendIds: this.friendIds,
					type: this.pendingMessage.type,
					content: this.pendingMessage.content
				}
			}).then(() => {
				this.$message.success('群发成功');
				this.confirmVisible = false;
				this.pendingMessage = null;
				this.resetEditor();
				this.loadRecords(true);
			}).finally(() => {
				this.isSending = false;
			});
		},
		resetEditor() {
			this.$nextTick(() => {
				this.$refs.chatInputEditor && this.$refs.chatInputEditor.clear();
				this.$refs.chatInputEditor && this.$refs.chatInputEditor.focus();
			});
		}
	}
}
</script>

<style lang="scss">
.mass-send-page {
	height: 100%;
	background: rgba(255, 255, 255, 1.0);
	text-align: left;
	.mass-aside {
		height: 100%;
		display: flex;
		flex-direction: column;
		background: rgba(255, 255, 255, 1.0);
		box-shadow: inset -1px 0px 0px 0px rgba(225, 229, 235, 1.0);
	}

	.header {
		height: 60px;
		display: flex;
		align-items: center;
		padding: 0 12px;
	}

	.group-scroll {
		flex: 1;
		min-height: 0;
	}

	.group-list {
		padding-bottom: 16px;
	}

	.group-title {
		height: 72px;
		display: flex;
		align-items: center;
		padding: 0 16px;
		box-sizing: border-box;
		cursor: pointer;
		box-shadow: inset -1px 0px 0px 0px rgba(225, 229, 235, 1.0);
		font-size: 20px;
		font-family: SourceHanSansCN-Medium;
		font-weight: 500;
		color: rgba(31, 31, 31, 1);
		i {
			font-size: 18px;
		}
		.group-checkbox {
			margin-left: 8px;
			margin-right: 4px;
		}
		.group-name {
			margin-left: 8px;
			flex: 1;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.group-count {
			font-size: 16px;
			color: rgba(135, 142, 153, 1);
		}
	}

	.letter {
		padding: 12px 0 0 42px;
		font-size: 16px;
		font-family: SourceHanSansCN-Medium;
		font-weight: 500;
		color: rgba(162, 171, 184, 1);
		line-height: 24px;
	}

	.member-item {
		height: 72px;
		display: flex;
		align-items: center;
		padding: 0 42px;
		box-sizing: border-box;
		box-shadow: inset -1px 0px 0px 0px rgba(225, 229, 235, 1.0);
		cursor: pointer;
		.el-checkbox {
			margin-right: 16px;
		}
		.member-name {
			font-size: 16px;
			font-family: SourceHanSansCN-Medium;
			font-weight: 500;
			color: rgba(31, 31, 31, 1);
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			margin-left: 12px;
		}
	}

	.add-group {
		height: 72px;
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 0 16px;
		font-size: 20px;
		font-family: SourceHanSansCN-Medium;
		font-weight: 500;
		color: rgba(31, 31, 31, 1);
		cursor: pointer;
		.el-icon-circle-plus-outline {
			font-size: 20px;
			font-weight: bold;
		}
	}

	.selected-actions {
		height: 64px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 12px;
		padding: 0 24px;
		box-sizing: border-box;
		background: rgba(250, 251, 252, 1.0);
		box-shadow: inset 0px 1px 0px 0px rgba(225, 229, 235, 1.0);
	}

	.mass-container {
		display: flex;
		flex-direction: column;
		background: rgba(255, 255, 255, 1.0);
	}

	.mass-header {
		height: 60px;
		line-height: 60px;
		padding: 0 24px;
		box-sizing: border-box;
		font-size: 20px;
		font-family: SourceHanSansCN-Medium;
		font-weight: 500;
		color: rgba(31, 31, 31, 1);
		box-shadow: inset 0px -1px 0px 0px rgba(225, 229, 235, 1.0);
	}

	.selected-tip {
		padding: 20px 24px;
		box-sizing: border-box;
		font-size: 14px;
		line-height: 22px;
		color: rgba(31, 31, 31, 1);
		background: rgba(250, 251, 252, 1.0);
		box-shadow: inset 0px -1px 0px 0px rgba(240, 242, 245, 1);

		span {
			font-weight: 600;
		}
	}

	.record-scroll {
		flex: 1;
		min-height: 0;
	}

	.record-list {
		padding: 24px 0;
	}

	.record-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 24px;
	}

	.record-time {
		font-size: 12px;
		font-family: SourceHanSansCN-Regular;
		font-weight: normal;
		color: rgba(162, 171, 184, 1);
		line-height: 18px;
		margin-bottom: 16px;
	}

	.record-card {
		width: 560px;
		max-width: calc(100% - 80px);
		background-color: rgba(250, 251, 252, 1.0);
		border-radius: 8px;
		padding: 16px;
		box-sizing: border-box;
	}

	.record-title {
		font-size: 16px;
		font-family: SourceHanSansCN-Medium;
		font-weight: 500;
		color: rgba(31, 31, 31, 1);
		line-height: 24px;
		margin-bottom: 16px;
	}

	.record-content {
		font-size: 16px;
		font-family: SourceHanSansCN-Regular;
		font-weight: normal;
		color: rgba(31, 31, 31, 1);
		line-height: 28px;
		white-space: pre-wrap;
		word-break: break-word;
		padding-bottom: 16px;
		border-bottom: 1px solid rgba(225, 229, 235, 1.0);
	}

	.record-media-list {
		padding-bottom: 16px;
		border-bottom: 1px solid rgba(225, 229, 235, 1.0);
	}

	.record-media {
		border-radius: 8px;
		overflow: hidden;
		max-width: 100%;

		&.record-media-audio {
			width: 100%;
		}

		.el-image {
			width: 100%;
			height: 100%;
		}

		video {
			display: block;
			width: 100%;
			height: 100%;
			background: #000;
		}

		audio {
			width: 100%;
			display: block;
		}

		.record-media-unknown {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			height: 100%;
			font-size: 14px;
			color: rgba(162, 171, 184, 1);
		}
	}

	.recipient-line {
		font-size: 14px;
		color: rgba(31, 31, 31, 1);
		line-height: 24px;
		margin-top: 16px;
		word-break: break-word;
		span {
			color: rgba(162, 171, 184, 1);
		}
	}

	.record-footer {
		display: flex;
		justify-content: flex-end;
		margin-top: 16px;
		.el-button {
			font-size: 16px;
			font-weight: 500;
			padding: 8px 12px;
		}
	}

	.load-tip,
	.empty-tip {
		text-align: center;
		font-size: 14px;
		color: rgba(162, 171, 184, 1);
		padding: 16px 0;
	}

	.send-panel {
		position: relative;
		margin: 12px;
		height: 240px;
		border: 1px solid rgba(240, 242, 245, 1);
		border-radius: 12px;
		box-sizing: border-box;

		.send-content-area {
			position: relative;
			display: flex;
			flex-direction: column;
			height: 100%;
		}

		.chat-tool-bar {
			display: flex;
			align-items: center;
			gap: 8px;
			color: #333;
			padding: 12px 12px 0;

			>div,
			>i {
				font-size: 20px;
				cursor: pointer;
				width: 32px;
				height: 32px;
				line-height: 32px;
				text-align: center;
				border-radius: 6px;
				display: flex;
				align-items: center;
				justify-content: center;

				&:hover {
					color: rgba(31, 90, 255, 1.0);
					background: rgba(31, 90, 255, 0.08);
				}
			}
		}

		.chat-input-area {
			flex: 1;
			min-height: 0;
		}

		.send-btn-area {
			padding: 8px 20px;
			display: flex;
			align-items: center;
			justify-content: flex-end;

			.el-button {
				padding: 9px 17px;
				font-size: 16px;
				background-color: rgba(31, 90, 255, 1.0);
				border-color: rgba(31, 90, 255, 1.0);
				border-radius: 8px;
			}
		}
	}
}

.mass-confirm-dialog {
	border-radius: 8px;

	.el-dialog__header {
		padding: 24px 24px 20px;
		border-bottom: 1px solid rgba(225, 229, 235, 1.0);
	}

	.el-dialog__title {
		font-size: 20px;
		font-family: SourceHanSansCN-Medium;
		font-weight: 500;
		color: rgba(31, 31, 31, 1);
	}

	.el-dialog__body {
		padding: 25px 24px;
	}

	.confirm-content {
		display: flex;
		align-items: flex-start;
		min-height: 44px;
		font-size: 14px;
		word-break: break-all;

		.confirm-label {
			color: rgba(162, 171, 184, 1);
			flex-shrink: 0;
			line-height: 26px;
		}

		.confirm-preview {
			color: rgba(31, 31, 31, 1);
			line-height: 26px;
		}
	}
}

.context-mask {
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 9999;
}

.mass-context-menu {
	position: fixed;
	z-index: 10000;
	width: 172px;
	padding: 8px 0;
	background-color: rgba(255, 255, 255, 1.0);
	border-radius: 12px;
	box-shadow: 0px 8px 24px 0px rgba(31, 35, 41, 0.12);
	border: 1px solid rgba(240, 242, 245, 1);

	.context-item {
		height: 48px;
		line-height: 48px;
		padding: 0 16px;
		box-sizing: border-box;
		font-size: 16px;
		font-family: SourceHanSansCN-Regular;
		font-weight: normal;
		color: rgba(31, 31, 31, 1);
		cursor: pointer;

		&:hover {
			background: rgba(250, 251, 252, 1.0);
		}

		&.danger {
			color: var(--im-color-danger);
		}
	}
}

.mass-group-dialog {
	border-radius: 8px;

	.el-dialog__header {
		padding: 24px 24px 20px;
		border-bottom: 1px solid rgba(225, 229, 235, 1.0);
	}

	.el-dialog__title {
		font-size: 20px;
		font-family: SourceHanSansCN-Medium;
		font-weight: 500;
		color: rgba(31, 31, 31, 1);
	}

	.el-dialog__body {
		padding: 25px 24px;
	}

	.el-input__inner {
		height: 56px;
		border-radius: 8px;
		font-size: 16px;
	}
}

.mass-edit-members-dialog {
	border-radius: 8px;

	.el-dialog__header {
		padding: 24px 24px 20px;
		border-bottom: 1px solid rgba(225, 229, 235, 1.0);
	}

	.el-dialog__title {
		font-size: 20px;
		font-family: SourceHanSansCN-Medium;
		font-weight: 500;
		color: rgba(31, 31, 31, 1);
	}

	.el-dialog__body {
		padding: 24px;
	}

	.edit-members {
		display: flex;
		align-items: stretch;

		.edit-box {
			flex: 1;
			display: flex;
			flex-direction: column;
			border: 1px solid rgba(225, 229, 235, 1.0);
			border-radius: 8px;
			overflow: hidden;

			.edit-box-header {
				padding: 8px;
				border-bottom: 1px solid rgba(225, 229, 235, 1.0);

				.edit-tip {
					font-size: 14px;
					color: rgba(135, 142, 153, 1);
					line-height: 32px;
					text-indent: 10px;
				}
			}

			.edit-member-scroll {
				height: 400px;
			}

			.edit-box-footer {
				display: flex;
				justify-content: flex-end;
				align-items: center;
				padding: 6px 10px;
				border-top: 1px solid rgba(225, 229, 235, 1.0);

				.edit-all-btn {
					font-size: 14px;
					padding: 0;
				}
			}

			.edit-member-item {
				display: flex;
				align-items: center;
				padding: 6px 10px;
				cursor: pointer;
				border-radius: 6px;
				margin: 2px 4px;

				&:hover {
					background: rgba(250, 251, 252, 1.0);
				}

				.edit-member-name {
					flex: 1;
					margin-left: 10px;
					font-size: 14px;
					color: rgba(31, 31, 31, 1);
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.edit-add-icon {
					font-size: 20px;
					color: rgba(31, 90, 255, 1.0);
				}

				.edit-remove-icon {
					font-size: 20px;
					color: rgba(245, 63, 63, 1.0);
				}
			}

			.edit-empty {
				text-align: center;
				font-size: 14px;
				color: rgba(162, 171, 184, 1);
				padding: 40px 0;
			}
		}

		.edit-arrow {
			display: flex;
			align-items: center;
			font-size: 18px;
			padding: 0 10px;
			color: rgba(31, 90, 255, 1.0);
		}
	}
}
</style>
